import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";

import Header from "./Component/Header/Header.js";
import Footer from "./Component/Footer/Footer";

import Knowledge from "./Component/Knowledge.js";
// import Goal from "./Component/Goal";
// import Impact from "./Component/Impact";
// import NewKnowledge from "./Component/NewKnowledge";
function App() {
  return (
    <div>
      <Router basename={"/Knowledge"}>
        <Header />
        <Routes key={"/Knowledge"}>
          <Route
            exact
            path="/"
            element={<Knowledge page="knowledge" value="" />}
          />
          <Route
            exact
            path="/goal"
            element={<Knowledge page="goal" value="" />}
          />
          <Route
            exact
            path="/impact"
            element={<Knowledge page="impact" value="" />}
          />
          <Route
            exact
            path="/newknowledge"
            element={<Knowledge page="newknowledge" value="" />}
          />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
